import React from 'react';
import { makeStyles } from '@material-ui/core';

import { ReactComponent as Icon } from '#web-components/assets/icons/newFolder.svg';
import styles from './FolderNew.styles';

const useStyles = makeStyles(styles, { name: 'FolderNewIcon' });

export default function FolderNewIcon() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Icon />
    </div>
  );
}
